<template>
    <div class="container is-fluid">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
                 
        <Nav style="margin-bottom: 20px;" />
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-12" style="margin-top: 70px;">
                    <template>
                        <div class="level">

                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <h4 class="title is-4">{{ $route.name }}</h4>
                                </div>
                            </div>
                            <div class="level-center">
                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                                <b-button type="is-success" @click="postUser(), clearUser()">{{getTextButtonActionUser()}}</b-button>
                            </div>
                        </div>
                    </template>
                    <template>
                        <div class="columns">
                            <div class="column is-7">
                                <div class="content is-medium">
                                    <div class="box">
                                        <b-tabs type="is-boxed" v-model="tabIndex" expanded>
                                            <b-tab-item label="View" icon="newspaper">
                                                <template>
                                                    <div>
                                                        <div>
                                                            <div class="field-body">
                                                                <div class="field">
                                                                    <VueFuse placeholder="Search"
                                                                             event-name="results"
                                                                             :list="users"
                                                                             :keys="['lastName']"
                                                                             class="input" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-table">
                                                            <div class="content table-users">
                                                                <table class="table is-fullwidth is-striped">
                                                                    <tbody>
                                                                        <tr v-for="user in users" :key="user.id">
                                                                            <td>{{ user.lastName + ' ' + user.firstName }}</td>
                                                                            <td class="level-right">
                                                                                <table class="level-right">
                                                                                    <tr>
                                                                                        <td>
                                                                                            <b-button type="is-primary"
                                                                                                      outlined
                                                                                                      @click="getUser(user.id)">View</b-button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <b-button type="is-primary"
                                                                                                      outlined
                                                                                                      @click="editUser(user.id)">Edit</b-button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <b-button :type="user.isActive == 0? 'is-danger':'is-primary'"
                                                                                                      outlined
                                                                                                      :disabled='isSpecialUser(user.email)'
                                                                                                      @click="disableUser(user.id,user.isActive)">{{user.isActive == 0? 'Active':'Inactive'}}</b-button>
                                                                                        </td>
                                                                                         <td>
                                                                                            <b-button type="is-danger"
                                                                                                      outlined
                                                                                                      :disabled='isSpecialUser(user.email)'
                                                                                                      @click="deletedUser(user.id)">X</b-button>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </td>

                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </b-tab-item>
                                            <b-tab-item label="Create" icon="newspaper">
                                                <Create @newUser="newUser = $event" />
                                            </b-tab-item>
                                            <b-tab-item label="Edit" icon="file-document-edit" v-bind:disabled="tabIndex !== 2">
                                                <div>
                                                    <div>
                                                        <b-field label="First Name">
                                                            <b-input v-model="selectedUser.firstName"></b-input>
                                                        </b-field>
                                                        <b-field label="Last Name">
                                                            <b-input v-model="selectedUser.lastName"></b-input>
                                                        </b-field>
                                                        <b-field label="Username AD" v-show="isEnabledUsernameAD()">
                                                            <b-input v-model="selectedUser.usernameAD"></b-input>
                                                        </b-field>
                                                        <b-field label="Email">
                                                            <b-input type="email" v-model="selectedUser.email"></b-input>
                                                        </b-field>
                                                        <b-field label="Password" v-show="isEnabledOnlyExternal()">
                                                            <b-input type="password"  v-model="selectedUser.password" password-reveal></b-input>
                                                        </b-field>
                                                    </div>
                                                    <div class="media-content--user">
                                                        <h5 class="subtitle is-5 is-spaced">Roles</h5>
                                                        <div class="columns">
                                                            <div class="column">
                                                                <section>
                                                                    <div class="field">
                                                                        <b-radio v-model="selectedUser.idRole" native-value="1">Admin</b-radio>
                                                                    </div>
                                                                    <div class="field">
                                                                        <b-radio v-model="selectedUser.idRole" native-value="2" type="is-succes">Operator</b-radio>
                                                                    </div>
                                                                </section>
                                                            </div>
                                                            <div class="column">
                                                                <section>
                                                                    <div class="field">
                                                                        <b-radio v-model="selectedUser.idRole" native-value="3" type="is-warning">Viewer</b-radio>
                                                                    </div>
                                                                    <div class="field">
                                                                        <b-radio v-model="selectedUser.idRole" native-value="4" type="is-danger">External</b-radio>
                                                                    </div>
                                                                </section>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-tab-item>

                                        </b-tabs>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-5">
                                <div class="content is-medium">
                                    <div class="box padding" v-if="typeof(selectedUser)!='undefined' && selectedUser!=null&&typeof(selectedUser.firstName)!='undefined'">
                                        <div class="media-content media-content--user">
                                            <p class="title is-1 has-text-info">{{ selectedUser.firstName + " " + selectedUser.lastName }}</p>
                                        </div>
                                        <div class="content" style="margin-top: 60px;">
                                            <div class="users">
                                                <h3 class="title has-text-info">First Name:</h3>
                                                <h4 class="subtitle">{{ selectedUser.firstName }}</h4>
                                            </div>
                                            <div class="users">
                                                <h3 class="title has-text-info">Last name:</h3>
                                                <h4 class="subtitle">{{ selectedUser.lastName }}</h4>
                                            </div>
                                            <div class="users">
                                                <h3 class="title has-text-info">Email:</h3>
                                                <h4 class="subtitle">{{ selectedUser.email }}</h4>
                                            </div>
                                            <div class="users">
                                                <h3 class="title has-text-info">Jobsite:</h3>
                                                <div class="tags">
                                                    <span v-for="(item, index) in selectedUser.jobsites"
                                                          :key="index"
                                                          class="tag is-info">{{item.nameJobsite}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box padding" v-else>
                                        <b>You must select a user</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueFuse from 'vue-fuse'
    // @ is an alias to /src
    import Nav from '@/components/Nav.vue'
    import Create from '@/components/User/Create.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {EMAILS} from '../store/data'

    export default {
        components: {
            Loading,
            Nav,
            Create,
            VueFuse,
        },
        data() {
            return {
                textButtonActionUser: 'Create User',
                tabIndex: 0,
                disabledEdit: true,
                isBusy: false,
                users: [],
                results: [],
                selectedUser: [],
                selected: [],
                newUser: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    usernameAD: '',
                    password: '',
                    idRole: '4',
                }
            }
        },
        methods: {
            disableUser(id, isActive) {
                try {
                    const self = this;
                    this.$buefy.dialog.confirm({
                        message: 'Confirm?',
                        onConfirm: () => {
                            this.isBusy = true;
                            this.axios
                                .get('/user/inactive/' + id + '?isActive=' + !isActive)
                                .then(response => {
                                    const genericResponse = response.data;
                                    if (genericResponse.isError == true) {
                                        this.$buefy.notification.open({
                                            message: `Error: ${genericResponse.messageError}`,
                                            position: 'is-bottom-right',
                                            type: 'is-danger',
                                            hasIcon: true,
                                        })
                                        this.isBusy = false;
                                        return;
                                    }

                                    setTimeout(function () {
                                        self.isBusy = false;
                                        self.clearUser();
                                        self.getAllUsers();

                                        self.$buefy.notification.open({
                                            message: `User edited!`,
                                            position: 'is-bottom-right',
                                            type: 'is-success',
                                            hasIcon: true,
                                        })
                                    }, 2000)
                                })
                                .catch(e => {
                                    console.error('error' + e)
                                    this.$buefy.notification.open({
                                        message: `Error: ${e.message}`,
                                        position: 'is-bottom-right',
                                        type: 'is-danger',
                                        hasIcon: true,
                                    })
                                    this.isBusy = false;
                                })
                        }
                    })
                } catch (e) {
                    this.$buefy.notification.open({
                        message: `Error: ${e.message}`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                }
            },

            deletedUser(id) {
                try{
                    const self = this;
                    this.$buefy.dialog.confirm({
                        message: 'Confirm?',
                        onConfirm: () => {
                            this.isBusy = true;
                            this.axios
                                .delete('/user/delete/' + id)
                                .then(response=>{
                                    const genericResponse = response.data;
                                    if (genericResponse.isError == true) {

                                        this.$buefy.notification.open({
                                            message: `Error: ${genericResponse.messageError}`,
                                            position: 'is-bottom-right',
                                            type: 'is-danger',
                                            hasIcon: true,
                                        })
                                    
                                        this.isBusy = false;
                                        return;
                                    }

                                    setTimeout(function () {
                                        self.isBusy = false;
                                        self.clearUser();
                                        self.getAllUsers();

                                        self.$buefy.notification.open({
                                            message: `User deleted!`,
                                            position: 'is-bottom-right',
                                            type: 'is-success',
                                            hasIcon: true,
                                        })
                                    }, 1000)
                                
                            })
                            .catch(e=>{
                                console.error("*** error ***", e)
                                this.$buefy.notification.open({
                                    message: `Error: ${e.message}`,
                                    position: 'is-bottom-right',
                                    type: 'is-danger',
                                    hasIcon: true,
                                })
                            this.isBusy = false;
                        })

                    }
                })
                }
                catch (e) {
                    this.$buefy.notification.open({
                        message: `Error: ${e.message}`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                }
            },

            isSpecialUser(email){
                const isThisEmailIsProtected = EMAILS.includes(email);
                let isSpecial = false;
                 if(isThisEmailIsProtected){
                    isSpecial = true;
                }
                return isSpecial;
            },

            isEnabledUsernameAD: function () {
                if (this.selectedUser.idRole == '4') {
                    this.selectedUser.usernameAD = '';
                    return false;
                }

                return true;
            },

            isEnabledOnlyExternal: function (){
                 if(this.isSpecialUser(this.selectedUser.email)){
                    return true;
                }
                if (this.selectedUser.idRole == '1' || this.selectedUser.idRole == '2' || this.selectedUser.idRole == '3') {
                    this.selectedUser.password = '';
                    return false;
                }
            },


            getTextButtonActionUser() {
                if (this.tabIndex == 2) {
                    return 'Save Edit User';
                }

                return 'Save New User';
            },


            
            getAllUsers() {
                this.isBusy = true;
                this.$store.dispatch('getUser').then(response => {
                    const genericResponse = response.data;
                    if (genericResponse.isError == true) {
                        this.$buefy.notification.open({
                            message: `Error: ${genericResponse.messageError}`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                        this.isBusy = false;
                        return;
                    }

                    this.isBusy = false;
                    this.users = genericResponse.result;

                }).catch(err => {
                    this.$buefy.notification.open({
                        message: `Error: ${err.message}`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                    this.isBusy = false;
                });
            },

            editUser(id) {
                this.tabIndex = 2;
                this.isBusy = true;

                this.axios
                    .get(`/user/${id}`)
                    .then(res => {
                        this.isBusy = false;
                        const genericResponse = res.data;

                        if (genericResponse.isError == true) {

                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                            return;
                        }

                        this.selectedUser = genericResponse.result;
                        this.selectedUser.password = '';
                        this.disabledEdit = false;
                    })
                    .catch(e => {
                        this.isBusy = false;
                        this.$buefy.notification.open({
                            message: `Error: ${e.message}`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            },
            getUser(id) {
                this.isBusy = true;

                this.axios
                    .get(`/user/${id}`)
                    .then(res => {
                        this.isBusy = false;
                        const genericResponse = res.data;

                        if (genericResponse.isError == true) {

                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                            return;
                        }
                        this.selectedUser = genericResponse.result;
                        this.selectedUser.password = '';
                    })
                    .catch(e => {
                        this.isBusy = false;
                        this.$buefy.notification.open({
                            message: `Error: ${e.message}`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            },
            clearUser() {
                this.newUser.firstName = ''
                this.newUser.lastName = ''
                this.newUser.email = ''
                this.newUser.password = ''
                this.newUser.usernameAD = ''
                this.newUser.idRole = '4'
            },
            postUser() {
                this.isBusy = true;
                const self = this;
                if (this.tabIndex == 2) {
                    this.axios
                        .put(`/user/${this.selectedUser.id}`, {
                            firstName: this.selectedUser.firstName,
                            lastName: this.selectedUser.lastName,
                            usernameAD: this.selectedUser.usernameAD,
                            email: this.selectedUser.email,
                            password: this.selectedUser.password,
                            idRole: this.selectedUser.idRole,
                        })
                        .then((response) => {
                            const genericResponse = response.data;
                            if (genericResponse.isError == true) {
                                this.isBusy = false;
                                this.$buefy.notification.open({
                                    message: `Error: ${genericResponse.messageError}`,
                                    position: 'is-bottom-right',
                                    type: 'is-danger',
                                    hasIcon: true,
                                })
                                return;
                            }
                            this.tabIndex = 0;


                            setTimeout(function () {
                                self.isBusy = false;
                                self.clearUser();
                                self.getAllUsers();

                                self.$buefy.notification.open({
                                    message: `User edited!`,
                                    position: 'is-bottom-right',
                                    type: 'is-success',
                                    hasIcon: true,
                                })
                            }, 2000)


                        })
                        .catch(error => {
                            this.isBusy = false;
                            console.error({ error })
                            this.$buefy.notification.open({
                                message: `Something Goes Wrong. Try Again.`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                        })

                } else {
                    //New User
                    this.axios
                        .post('/user', {
                            firstName: this.newUser.firstName,
                            lastName: this.newUser.lastName,
                            usernameAD: this.newUser.usernameAD,
                            email: this.newUser.email,
                            password: this.newUser.password,
                            idRole: this.newUser.idRole,
                        })
                        .then((response) => {
                            this.isBusy = false;
                            const genericResponse = response.data;
                            if (genericResponse.isError == true) {
                                this.$buefy.notification.open({
                                    message: `Error: ${genericResponse.messageError}`,
                                    position: 'is-bottom-right',
                                    type: 'is-danger',
                                    hasIcon: true,
                                })
                                return;
                            }

                            setTimeout(function () {
                                self.isBusy = false;
                                self.clearUser();
                                self.getAllUsers();

                                this.$buefy.notification.open({
                                    message: `New user created!`,
                                    position: 'is-bottom-right',
                                    type: 'is-success',
                                    hasIcon: true,
                                })
                            }, 2000)

                        })
                        .catch(error => {
                            this.isBusy = false;
                            console.error({ error })
                            this.$buefy.notification.open({
                                message: `Something Goes Wrong. Try Again.`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                        })
                }
            },
        },

        created() {
            
            this.isBusy = true;
            const self = this;
            this.$store.dispatch('verifyAccess').then(() => {
                self.isBusy = false;
                self.$on('results', results => {
                    self.results = results
                })
            });
        },
        mounted() {
            this.getAllUsers();
        }

    }
</script>
<style lang="scss">

    .user-select {
        margin: -8px -8px -8px 0;
        height: 74vh;
        &-body

    {
        height: 66vh;
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        background: #fff;
        padding: 16px;
    }

    }

    .card-table {
        max-height: 460px;
        overflow-y: scroll;
        margin-top: 10px;
        border: 1px solid #dfdfdf;
        border-radius: 8px 0 0 8px;
    }

    .media-content--user {
        background: hsl(0, 0%, 96%);
        margin: -1.25em -1.25em -1.25em -1.25em;
        margin-top: 0.75em;
        padding: 2.25em 1.25em 0.8em 1.25em;
        border-radius: 0 0 6px 6px;
    }

    .subtitle.is-5 {
        margin-top: 10px;
    }
</style>

